import { Pipe, PipeTransform } from '@angular/core';
import { DataTableColDef } from '../interfaces/col-def.interface';

@Pipe({
  name: 'gridColCount'
})
export class GridColCountDataPipe implements PipeTransform {
  transform(columns: DataTableColDef[], base: number): number {
    if (!columns || columns.length === 0) {
      return 0;
    }

    return columns.map((col) => col.size ?? 1).reduce((prev, next) => prev + next, base);
  }
}
